import script from "./Searchbar.vue?vue&type=script&setup=true&lang=js"
export * from "./Searchbar.vue?vue&type=script&setup=true&lang=js"

import "./Searchbar.vue?vue&type=style&index=0&id=58c5fa4c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58c5fa4c"]])

export default __exports__